module.exports = __webpack_public_path__ + "static/media/11x14no3.431a608a.jpg";